import { Box, Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { assertImagesUrl } from "../../../redux/common";

interface ImageUploadDragAndDropProps {
    value: string;
    onChange: (img: string) => void;
    alt: string;
}

const ImageUploadDragAndDrop = ({ value, onChange, alt }: ImageUploadDragAndDropProps) => {
    const [imagePreview, setImagePreview] = useState<string>(value || "");
    const [dragOver, setDragOver] = useState(false);

    const handleFileChange = (file: File) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.result && typeof reader.result === "string") {
                setImagePreview(reader.result);
                onChange(reader.result);
            }
        };
        reader.readAsDataURL(file);
    };

    const handleDrag = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        setDragOver(event.type === "dragover");
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        setDragOver(false);
        const files = event.dataTransfer.files;
        if (files && files[0]) {
            handleFileChange(files[0]);
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files[0]) {
            handleFileChange(event.target.files[0]);
        }
    };

    return (
        <Box
            sx={{
                border: dragOver ? "2px dashed #1976d2" : "2px dashed #ccc",
                borderRadius: 2,
                p: 2,
                textAlign: "center",
                cursor: "pointer",
                background: dragOver ? "#f0f7ff" : "inherit"
            }}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
        >
            <Stack spacing={2} alignItems="center" direction={"row"}>
                <Stack spacing={2} alignItems="center" direction={"column"} width={"200px"}>
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <label htmlFor="image-upload-drag-drop">
                            <Button variant="contained" component="span">
                                {imagePreview ? "Alterar imagem" : "Selecionar imagem"}
                            </Button>
                        </label>
                    </Box>
                    
                    <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id="image-upload-drag-drop"
                        type="file"
                        onChange={handleInputChange}
                    />
                    
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        Arraste uma imagem para esta área ou clique para selecionar.
                    </Typography>
                </Stack>

                {imagePreview && (
                    <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                        <img
                            src={assertImagesUrl(imagePreview)}
                            alt={alt}
                            style={{
                                maxWidth: "200px",
                                maxHeight: "200px",
                                width: "auto",
                                height: "auto",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "4px"
                            }}
                        />
                    </Box>
                )}
                
            </Stack>
        </Box>
    );
};

export default ImageUploadDragAndDrop;
